import { culture } from '../../utils/intl';

const API_URL_BASE = `/api/${culture}/alphabetical/underlyings`;

const handleFetch = (url, fetchOptions = {}, returnJson = true) => fetch(url, fetchOptions)
	.then((res) => {
		if (res.ok) {
			return returnJson ? res.json() : true;
		}

		throw Error('Something went wrong while fetching');
	});

const get = async params => handleFetch(`${API_URL_BASE}${params}`);

export {
	get,
};
